import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "motion/react";
import { assets, hero } from "../content/siteContent";

export function Hero() {
  const reduceMotion = useReducedMotion();

  return (
    <section className="hero technical-frame" aria-labelledby="hero-title">
      <motion.div
        className="hero-copy"
        initial={reduceMotion ? false : { opacity: 0, x: -18 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      >
        <h1 id="hero-title" aria-label={hero.title}>
          <span className="hero-title-line">Αθλητικός</span>{" "}
          <span className="hero-title-line">Σκοπευτικός</span>{" "}
          <span className="hero-title-line">Όμιλος Ωμέγα</span>
        </h1>
        <p>{hero.text}</p>
        <Link className="button button--primary" to="/epikoinonia" data-target>
          {hero.cta}
          <ArrowRight aria-hidden="true" />
        </Link>
      </motion.div>

      <motion.div
        className="hero-media"
        initial={reduceMotion ? false : { opacity: 0, scale: 1.015 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.75, delay: 0.08, ease: [0.22, 1, 0.36, 1] }}
      >
        <img src={assets.hero} alt="Πεδίο βολής για προπόνηση σκοποβολής του ΑΣΟ Ωμέγα" />
        <span className="hero-optical-blur" aria-hidden="true" />
        <span className="hero-meta" aria-hidden="true">
          RNG: 25m<br />MODE: TRAINING
        </span>
      </motion.div>
    </section>
  );
}
